import { Component, OnInit } from '@angular/core';
import { CodeModel, parameterDataTypes } from 'shared/definition';
import { GenericApiService, SpinningService } from 'shared/services';
import { GenericApiFactory } from 'shared/factories';
import {
  MAX_500_LENGTH,
  MAX_100_LENGTH
} from 'shared/consts/validator-contstants';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidateService } from 'app/service/validate.service';
import { tap } from 'rxjs/operators';
import { messages } from 'shared/consts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
@Component({
  selector: 'app-parameter-code-form',
  templateUrl: './parameter-code-form.component.html',
  styleUrls: ['./parameter-code-form.component.scss']
})
export class ParameterCodeFormComponent implements OnInit {

  form: FormGroup;
  size = {
    label: '100px',
    control: 'auto'
  };
  model: CodeModel;
  apiName: string;
  api: GenericApiService<CodeModel, any>;
  max100Length = MAX_100_LENGTH;
  max500Length = MAX_500_LENGTH;
  dataTypes = parameterDataTypes;
  constructor(
    fb: FormBuilder,
    private modalRef: NzModalRef,
    private validateService: ValidateService,
    private spinningService: SpinningService,
    private messageService: NzMessageService,
    private genericApiFactory: GenericApiFactory,
  ) {
    this.form = fb.group({
      'name': fb.control(null, [Validators.required]),
      'description': fb.control(null, null),
      'dataType': fb.control(null, [Validators.required])
    });
  }

  ngOnInit(): void {
    this.api = this.genericApiFactory.create<CodeModel, any>(this.apiName);
    if (this.model) {
      this.form.patchValue(this.model);
    }
  }

  save() {
    for (const key in this.form.controls) {
      this.form.controls[key].updateValueAndValidity();
      this.form.controls[key].markAsDirty();
    }
    if (this.form.invalid) return;
    const model = {
      ...this.model,
      ...this.form.value
    }
    const save$ = model.id ? this.api.update(model) : this.api.create(model);
    this.spinningService.startWith(save$).pipe(
      tap((x) => {
        if (x) {
          this.messageService.info(messages.saveSuccessfully);
          this.modalRef.close(true)
        }
      })
    ).subscribe();
  }
  cancel() {
    this.modalRef.close(false);
  }

}
